import React, { useState, useEffect } from 'react';
import PromotionBanner from '@/components/promotions/PromotionBanner';
import BonusCards from '@/components/promotions/BonusCards';
import PromotionGuestView from '@/components/promotions/PromotionGuestView';
import styles from './Promotions.module.css';

/**
 * Promotions Page Component
 * Shows deposit bonuses and promotions for both logged-in and non-logged-in users
 */
const Promotions = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // Check login status
  useEffect(() => {
    const checkAuthStatus = () => {
      const token = localStorage.getItem('token');
      setIsLoggedIn(!!token);
    };

    checkAuthStatus();
    window.addEventListener('storage', checkAuthStatus);
    return () => window.removeEventListener('storage', checkAuthStatus);
  }, []);

  return (
    <div className={styles.container}>
      {isLoggedIn ? (
        <>
          {/* Main Promotion Banner with 4 Deposit Cards */}
          <PromotionBanner />
          
          {/* Additional Bonus Cards for Logged-in Users */}
          <BonusCards />
        </>
      ) : (
        <>
          {/* Guest View Banner */}
          <PromotionGuestView />
          
          {/* Show promotion banner to guests as well */}
          <PromotionBanner />
        </>
      )}
    </div>
  );
};

export default Promotions;
